
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#959595","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.5 1.5H11v-1a.5.5 0 10-1 0v1H4v-1a.5.5 0 10-1 0v1H1.5A1.5 1.5 0 000 3v9.5A1.5 1.5 0 001.5 14h11a1.5 1.5 0 001.5-1.5V3a1.5 1.5 0 00-1.5-1.5zm.5 11a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5V6h12zM13 5H1V3a.5.5 0 01.5-.5H3v1a.5.5 0 101 0v-1h6v1a.5.5 0 101 0v-1h1.5a.5.5 0 01.5.5v2z","fill":"inherit","opacity":".5"}})])
          )
        }
      }
    